import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-gold bg-pitch" data-id="element-94" data-mp="9lbg511q9bdl">
      <p className="bg-field px-3 py-1.5 text-center font-sub text-sm font-extrabold uppercase leading-tight tracking-wide text-white" data-id="element-95" data-mp="4m8n6ez0uvlz">
        Método de aprendizaje paso a paso
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-4 pt-3 text-center sm:px-5" data-id="element-96" data-mp="xanojyp8dfeu">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[2rem] font-normal uppercase leading-[1.05] text-white sm:text-5xl" data-id="element-97" data-mp="x8jndoipuui9">
          El sistema completo para aprender a{' '}
          <span className="text-gold" data-id="element-98" data-mp="382p55bt4dbkm">entrenar fútbol</span>{' '}
          <span className="bg-field px-1.5 text-white" data-id="element-99" data-mp="384jsewrv5frv">desde cero</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/85" data-id="element-100" data-mp="3j9agbasosm43">
          Aprende a planificar entrenamientos, enseñar técnicas, aplicar
          tácticas y dirigir equipos de diferentes edades con un método
          organizado,{' '}
          <strong className="font-bold text-white" data-id="element-101" data-mp="358rdqj6zq89b">
            sin perderte entre cientos de ejercicios, videos y formaciones.
          </strong>
        </motion.p>

        <p className="mt-2 inline-block rounded-lg border border-gold/60 bg-pitch-soft px-3 py-1.5 font-sub text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-102" data-mp="2qlogmdmky1mi">
          {PRODUCT_NAME} ·{' '}
          <span className="text-gold" data-id="element-103" data-mp="2lkqzm4db3dml">6 Tomos + 5 Bonos</span>
        </p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-2 block overflow-hidden rounded-2xl border-4 border-gold bg-pitch-soft" data-id="element-104" data-mp="2ljz1omw8l3t5">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-105" data-mp="ia5f4mct1xow" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-bold leading-snug text-white/80 sm:text-sm" data-id="element-106" data-mp="1b04at0li8t2j">
          {PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos
        </p>

        <div className="mt-2.5" data-id="element-107" data-mp="111etb8xitamt">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-108" data-mp="114svoh66pju9">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-109" data-mp="3lsysay1o8kij">
            Acceso Digital Inmediato • Garantía de 7 Días
          </p>
        </div>
      </div>
    </header>;
}